<template>
  <div class="Product flex-column">
    <div class="page-title">{{ $t("title.product") }}</div>
    <div class="flex flex-fixed">
      <div class="tree-container">
        <AProductTypeTreeSelector @select="handleSelectProductType" />
      </div>
      <div style="width:calc(100% - 170px);">
        <ATable
          ref="table"
          class-search-container="searchContainer"
          buttons-width="250px"
          :placeholder="placeholder"
          :search_field="search_field"
          :data="items"
          :page-size="35"
          :disable_insert="!has_grant_write"
          border
          @cell-click="handleClickCell"
          @clicked-create="handleClickCreate"
          @selection-change="handleSelectionChange"
        >
          <div slot="search" class="inline">
            <div class="inline">
              <el-select
                size="mini"
                v-model="search_sale_type_id"
                :placeholder="$t('lang.sales_classification')"
              >
                <el-option :key="0" :value="0" label="전체" />
                <el-option
                  v-for="item in table_sale_type"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-select
                size="mini"
                v-model="search_category_id"
                style="margin-left:10px"
                placeholder="제품구분"
              >
                <el-option :key="0" :value="0" label="전체" />
                <el-option
                  v-for="item in table_product_category"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <el-checkbox v-model="show_hide" style="margin-left:10px">
                숨겨진 항목 보기
              </el-checkbox>
            </div>
          </div>
          <el-table-column
            type="selection"
            align="center"
            :width="$width.selection"
          />
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex"
            :width="$width.indexw"
          />
          <el-table-column prop="code" :label="$t('lang.code')" width="80" />
          <el-table-column
            prop="sale_type_id"
            width="80"
            :label="$t('lang.sales_classification')"
            :formatter="resolveSaleTypeFlag"
          />
          <el-table-column
            prop="name"
            label="품목명"
            min-width="320"
            show-overflow-tooltip
          />
          <el-table-column label="이미지" width="60">
            <template slot-scope="scope">
              <div v-if="scope.row.image_name" class="align-center">
                <el-popover trigger="click">
                  <img
                    :src="
                      getImageUrl(scope.row) + '?time=' + new Date().getTime()
                    "
                  />
                  <el-button
                    slot="reference"
                    size="mini"
                    icon="el-icon-search"
                    plain
                  />
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="size"
            label="규격"
            width="90"
            show-overflow-tooltip
          />
          <el-table-column
            prop="categories"
            width="140"
            show-overflow-tooltip
            label="제품구분"
            :formatter="resolveCategoriesFlag"
          />
          <el-table-column
            prop="unit_id"
            width="50"
            :label="$t('lang.unit')"
            :formatter="resolveUnitsFlag"
          />
          <el-table-column
            prop="use_flag"
            width="50"
            :label="$t('lang.state')"
            :formatter="
              (row, cell, cellValue) => (cellValue === 'Y' ? '사용' : '미사용')
            "
          />
          <el-table-column
            prop="kind"
            label="기계"
            width="50"
            :formatter="
              (row, cell, cellValue) => (cellValue === 'GOODS' ? '표기' : ' ')
            "
          />
          <el-table-column
            prop="desc"
            width="100"
            :label="$t('lang.desc')"
            show-overflow-tooltip
          />
          <el-table-column
            prop="is_hide"
            width="50"
            label="숨김"
            :formatter="
              (row, cell, cellValue) => (cellValue === 'Y' ? 'Y' : '')
            "
          />
          <el-table-column
            prop="is_manage_stock"
            width="70"
            label="재고관리"
            :formatter="
              (row, cell, cellValue) => (cellValue === 'Y' ? 'Y' : '')
            "
          />
          <el-table-column
            prop="created_user_name"
            :label="$t('lang.created_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="modified_user_name"
            :label="$t('lang.modified_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="created_at"
            :label="$t('lang.created_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <el-table-column
            prop="modified_at"
            :label="$t('lang.modified_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <div slot="buttons">
            <el-button
              :disabled="selection.length < 1 || !has_grant_write"
              @click="handleClickBulkChange"
              >{{ $t("button.bulk_change") }}</el-button
            >
            <el-button
              type="danger"
              :disabled="selection.length < 1 || !has_grant_write"
              :loading="load_button"
              @click="handleClickDelete"
              >삭제</el-button
            >
          </div>
        </ATable>
      </div>
    </div>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      destroyOnClose
      :title="$t('lang.material_logon')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <ProductForm
        ref="form"
        v-if="dialog_visible"
        :data="selectedData"
        :has_grant_write="has_grant_write"
        @handleClickedCreate2="handleClickedCreate2"
        @completed="handleCompleted"
      />
    </el-dialog>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="400px"
      destroyOnClose
      :title="$t('button.bulk_change')"
      :visible.sync="dialog2_visible"
      :close-on-click-modal="false"
    >
      <ProductBulkChange
        v-if="dialog2_visible"
        :ids="selectionIds"
        :has_grant_write="has_grant_write"
        @completed="handleCompletedBulkChange"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import ProductForm from "./ProductForm";
import ProductBulkChange from "./ProductBulkChange";

export default {
  name: "Product",
  mixins: [form_container, authority_level],
  components: { ProductForm, ProductBulkChange },
  data() {
    return {
      title: this.$t("title.product"),
      placeholder: "코드, 품목명, 규격, 비고",
      search_field: ["code", "name", "size", "desc"],
      search_type_id: 0,
      search_sale_type_id: null,
      selectedData: undefined,
      dialog_visible: false,
      dialog2_visible: false,
      selection: [],
      search_category_id: null,
      show_hide: false,
      load_button: false,
    };
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_product_type",
      "table_product_category",
      "table_product_option",
      "table_sale_type",
      "table_unit",
    ]),
    items: function() {
      return this.table_product
        .filter((item) => {
          return (
            (this.search_type_id > 0
              ? item.type_id === this.search_type_id
              : true) &&
            (this.search_sale_type_id > 0
              ? item.sale_type_id === this.search_sale_type_id
              : true) &&
            (this.search_category_id > 0
              ? item.categories.find(
                  (findItem) =>
                    findItem.product_category_id === this.search_category_id
                )
              : true) &&
            (this.show_hide ? true : item.is_hide === "N")
          );
        })
        .sort(this.util.sortByName);
    },
    selectionIds() {
      if (this.selection.length < 1) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return [];
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.selection.map((s) => s.id);
    },
    has_grant_write() {
      return this.isWriteLevel("product");
    },
  },
  methods: {
    /** 다이얼로그 팝업 */
    openDialog(data) {
      let clone = data ? this.util.looseClone(data) : undefined;
      if (clone) {
        clone.categories = clone.categories.map(
          (item) => item.product_category_id
        );
      }
      this.selectedData = clone;
      this.dialog_visible = true;
    },
    openDialog2() {
      this.dialog_visible2 = true;
    },
    optionsFormat(row, cell, cellValue) {
      let options = cellValue.map((option) => option.product_option_id);
      options = this.table_product_option.filter(
        (option) => options.indexOf(option.id) > -1
      );
      options = options.map((option) => option.name);
      return options.join(", ");
    },
    doDelete() {
      let params = this.selectionIds;
      this.load_button = true;
      this.api.deleteProductBulk(params).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        if (res.unDeleted.length) {
          for (let i = 0; i < res.unDeleted.length; i++) {
            this.util.notify_warning(
              this,
              this.title,
              this.items.find((item) => item.id === res.unDeleted[i]).name +
                "은(는) BOM이 존재하여 삭제되지 않았습니다."
            );
          }
        }
        if (res.unDeleted.length !== params.length) {
          this.util.notify_success(this, this.title, "삭제되었습니다.");
        }
      });
    },
    getImageUrl(product) {
      return "/api/product/image/" + product.id;
    },
    /** 단위 필터(Unit filter) */
    resolveUnitsFlag(row, column, value) {
      const type = this.table_unit.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveSaleTypeFlag(row, column, value) {
      const type = this.table_sale_type.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveTypesFlag(row, column, value) {
      const type = this.table_product_type.filter((f) => f.id === value);
      if (type.length > 0) return type ? type[0].name : "";
    },
    resolveCategoriesFlag(row, column, value) {
      if (!value) {
        return "";
      }
      const arrStr = [];
      value.map((item) => {
        const type = this.table_product_category.filter(
          (f) => f.id === item.product_category_id
        );
        if (type.length > 0) arrStr.push(type ? type[0].name : "");
      });
      return arrStr.join(",");
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    /** 데이터 선택 */
    handleClickCell(data, column) {
      if (!column.property) {
        return;
      }
      this.openDialog(data);
    },
    /** 신규 등록*/
    handleClickCreate() {
      this.openDialog();
    },
    handleClickedCreate2() {
      this.openDialog2();
    },
    /**  폼 처리 완료 */
    handleCompleted(message) {
      this.dialog_visible = false;
      this.dialog2_visible = false;
      this.dialog3Visible = false;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
    handleSelectProductType(value) {
      this.search_type_id = value;
    },
    handleClickRegisterBOM(data) {
      this.selectedData = data;
      this.dialog2_visible = true;
    },
    handleClickViewBOM(data) {
      this.selectedData = data;
      this.dialog3Visible = true;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleClickDelete() {
      let message = "삭제하시겠습니까?\nBOM에 등록된 품목은 삭제되지 않습니다.";
      this.util.confirm(this, this.title, message, this.doDelete, true);
    },
    handleClickBulkChange() {
      this.dialog2_visible = true;
    },
    handleCompletedBulkChange() {
      this.dialog2_visible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.tree-container {
  min-width: 160px;
  overflow: auto;
  flex: 0 0;
  margin-right: 10px;
  border: $border-dark;
}
</style>
